module.exports = __webpack_public_path__ + "static/img/company_logo_icon.873fbff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_logo_icon.png
// module id = hQ8m
// module chunks = 1